<template>
  <div>
    <v-autocomplete
      :items="items"
      item-text="text"
      item-value="id"
      v-model="contextModel"
      :label="$t('components.ajaxBookingRailSelect.label')"
      append-icon="train"
      :error-messages="validationMessage"
      @focus="openDialog"
      :menu-props="{ value: false }"
    >
      <template slot="selection" slot-scope="data">
        <v-chip small :selected="data.selected" :key="JSON.stringify(data.item)" @click="openDialog">
          {{ data.item.text }}
        </v-chip>
      </template>
    </v-autocomplete>
    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("components.ajaxBookingRailSelect.railBookingList") }}</span>
          <v-spacer />
          <v-col cols="6">
            <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details />
          </v-col>
        </v-card-title>

        <booking-rail-data-table :search="search">
          <div slot="action-column" slot-scope="item">
            <v-btn icon class="ma-0" disabled v-if="isWNBUser" :title="$t('components.ajaxBookingRailSelect.showBookingDetails')">
              <v-icon>remove_red_eye</v-icon>
            </v-btn>
            <v-tooltip z-index="500" top>
              <template #activator="{on}">
                <v-btn icon class="ma-0" v-on="on" @click="assignBooking(item.booking)" :disabled="$store.getters['Ajax/loading']">
                  <v-icon>mdi-pin</v-icon>
                </v-btn>
              </template>
              {{ $t("components.ajaxBookingRailSelect.pinBooking") }}
            </v-tooltip>
            <v-tooltip z-index="500" top>
              <template #activator="{on}">
                <v-btn
                  @click="importRoute(item.booking)"
                  v-on="on"
                  icon
                  class="ma-0"
                  :disabled="$store.getters['Ajax/loading']"
                  :title="$t('components.ajaxBookingRailSelect.importRoute')"
                >
                  <v-icon>train</v-icon>
                </v-btn>
              </template>
              {{ $t("components.ajaxBookingRailSelect.importRoute") }}
            </v-tooltip>
          </div>
        </booking-rail-data-table>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="dialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayOfWeek from "../../repository/dayOfWeekFromDate";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import BookingRailDataTable from "../Booking/BookingRailDataTable.vue"; // webpack alias

export default {
  name: "AjaxBookingRailSelect",
  components: { BookingRailDataTable },
  props: {
    readonly: {
      required: false,
      default: false
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    model: {
      required: true
    },
    ticketNumber: {
      required: false,
      default: null
    },
    fileId: {
      required: false,
      default: null
    }
  },
  data: () => ({
    newId: -1,
    uploadButton: true,
    dialog: false,
    validationError: false,
    //validationMessage: [],
    //items: [],
    search: "",
    uploadedFile: null,
    //loading: false,

    loading: false
  }),
  watch: {
    selectModel(val) {
      this.onChange(val);
    }
  },
  computed: {
    items() {
      if (this.model != null) {
        return [{ id: this.model, text: "" + this.ticketNumber }];
      }
      return [];
    },
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    },
    isWNBUser() {
      return this.$store.getters["isWnbUser"];
    }
  },
  methods: {
    openDialog() {
      if (this.readonly !== true) {
        this.dialog = true;
      }
    },
    // eslint-disable-next-line no-unused-vars
    showBookingDetails(item) {
      alert("Funkcjonalność w trakcie realizacji");
    },
    assignBooking(item) {
      this.$emit("update:model", item.id);
      this.$emit("update:ticketNumber", item.railAttributes.carrier + " " + item.railAttributes.ticket_number);
      let self = this;
      this.axios.get("delegation/get-booking-file?bookingId=" + item.id).then(resp => {
        self.$emit("fileRemoved", { id: self.contextFileId });
        this.contextFileId = resp.data.file_id;
        const newItem = {
          id: resp.data.file_id,
          itemName: resp.data.file_name,
          status: this.$t("global.generatedServerSide"),
          fileSize: 0,
          uploadedSize: 0
        };
        self.$emit("fileUploaded", newItem);
        self.$emit("update:fileId", resp.data.file_id);
      });
      this.dialog = false;
    },
    importRoute(item) {
      this.$emit("importRailRoute", item);
      this.assignBooking(item);
    },
    dayOfWeek: dayOfWeek,
    filterOverAllProperty: filterOverAllProperty
  },
  created() {},
  beforeDestroy() {
    this.$emit("update:model", null);
    this.$emit("update:ticketNumber", null);
    this.$emit("fileRemoved", { id: this.contextFileId });
  }
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}
</style>
